var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIconClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.88576 7.22222V4.55556C3.88576 2.59111 5.72691 1 8.00005 1C10.2732 1 12.1143 2.59111 12.1143 4.55556V7.22222M8.00005 11.6667C8.27284 11.6667 8.53446 11.573 8.72736 11.4063C8.92025 11.2396 9.02862 11.0135 9.02862 10.7778C9.02862 10.542 8.92025 10.3159 8.72736 10.1492C8.53446 9.98254 8.27284 9.88889 8.00005 9.88889C7.72725 9.88889 7.46563 9.98254 7.27274 10.1492C7.07984 10.3159 6.97148 10.542 6.97148 10.7778C6.97148 11.0135 7.07984 11.2396 7.27274 11.4063C7.46563 11.573 7.72725 11.6667 8.00005 11.6667ZM8.00005 11.6667V14.3333M2.44576 7.22222H13.5543C14.4595 7.22222 15.2 7.86222 15.2 8.64444V14.8667C15.2 16.04 14.0892 17 12.7315 17H3.26862C1.91091 17 0.800049 16.04 0.800049 14.8667V8.64444C0.800049 7.86222 1.54062 7.22222 2.44576 7.22222Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIconClose);
export default __webpack_public_path__ + "static/media/lock-icon-close.0da6eac38b10015cdadd913c727b02d5.svg";
export { ForwardRef as ReactComponent };